import { render, staticRenderFns } from "./land-contacts.vue?vue&type=template&id=109d8d4a"
import script from "./land-contacts.vue?vue&type=script&lang=js"
export * from "./land-contacts.vue?vue&type=script&lang=js"
import style0 from "./land-contacts.vue?vue&type=style&index=0&id=109d8d4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports